"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledCheckbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));

var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));

var _styles = require("@mui/material/styles");

var _templateObject;

var _excluded = ["style", "disabled", "checked", "onChange", "name"],
    _excluded2 = ["label"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledCheckbox = (0, _styles.styled)(function (props) {
  var style = props.style,
      disabled = props.disabled,
      checked = props.checked,
      onChange = props.onChange,
      name = props.name,
      others = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({}, others, {
    inputProps: {
      'aria-label': checked ? 'checked-label' : 'unchecked-label'
    },
    "aria-checked": checked,
    disabled: disabled,
    checked: checked,
    onChange: onChange,
    name: name
  }));
})(function (_ref) {
  var theme = _ref.theme;
  return "\n    color: ".concat(theme.palette.font.primary, ";\n");
});
exports.StyledCheckbox = StyledCheckbox;
var StyledBrandCheckbox = (0, _styles.styled)(function (props) {
  var label = props.label,
      others = _objectWithoutProperties(props, _excluded2);

  if (!label) {
    return /*#__PURE__*/_react.default.createElement(StyledCheckbox, others);
  }

  return /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
    label: label,
    control: /*#__PURE__*/_react.default.createElement(StyledCheckbox, others)
  });
})(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var BrandCheckbox = function BrandCheckbox(props) {
  return /*#__PURE__*/_react.default.createElement(StyledBrandCheckbox, props);
};

var _default = BrandCheckbox;
exports.default = _default;